import { render, staticRenderFns } from "./bindSupplier.vue?vue&type=template&id=03baa96c&scoped=true&"
import script from "./bindSupplier.vue?vue&type=script&lang=js&"
export * from "./bindSupplier.vue?vue&type=script&lang=js&"
import style0 from "./bindSupplier.vue?vue&type=style&index=0&id=03baa96c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03baa96c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\www\\ssz_gold_backend\\multi_merchant_web\\gold_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03baa96c')) {
      api.createRecord('03baa96c', component.options)
    } else {
      api.reload('03baa96c', component.options)
    }
    module.hot.accept("./bindSupplier.vue?vue&type=template&id=03baa96c&scoped=true&", function () {
      api.rerender('03baa96c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/merchant/bindSupplier.vue"
export default component.exports